import * as XLSX from 'xlsx';
import hoyHora from './hoy'
const generateXls = (processedItems, filename) => {
    let data = XLSX.utils.json_to_sheet(processedItems)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, data, filename)
    XLSX.writeFile(workbook, `${filename}-${hoyHora()}.xlsx`)
}

export default generateXls
